<app-banner [title]="'Accueil'" [links]="links"></app-banner>

<div class="container">
	<p class="text-[#141414]! font-bold! text-3xl!">Bonjour, &nbsp;<span class="text-[#141414]! font-bold! text-3xl!">{{
			(userData$ | async)?.firstName }} {{ (userData$ | async)?.lastName }}</span></p>

	<!-- Dashboard statistics cards -->
	<ng-container *ngIf="statistics$ | async as stats">
		<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 my-6">
			<!-- Nbr prestations médicales -->
			<div class="flex items-center p-4 bg-white rounded-lg shadow-sm">
				<div
					class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-100 text-blue-600 text-xl mr-4">
					🏥</div>
				<div>
					<div class="text-sm text-gray-500">Nbr prestations médicales</div>
					<div class="text-2xl font-semibold text-gray-900">{{ stats.medicalPrestationsCount }}</div>
				</div>
			</div>

			<!-- Nbr prestations financières -->
			<div class="flex items-center p-4 bg-white rounded-lg shadow-sm">
				<div
					class="flex items-center justify-center w-12 h-12 rounded-full bg-emerald-100 text-emerald-600 text-xl mr-4">
					💵</div>
				<div>
					<div class="text-sm text-gray-500">Nbr prestations financières</div>
					<div class="text-2xl font-semibold text-gray-900">{{ stats.financialPrestationsCount }}</div>
				</div>
			</div>

			<!-- Nbr Ordonnances -->
			<div class="flex items-center p-4 bg-white rounded-lg shadow-sm">
				<div
					class="flex items-center justify-center w-12 h-12 rounded-full bg-violet-100 text-violet-600 text-xl mr-4">
					📄</div>
				<div>
					<div class="text-sm text-gray-500">Nbr ordonnances</div>
					<div class="text-2xl font-semibold text-gray-900">{{ stats.prescriptionsCount }}</div>
				</div>
			</div>

			<!-- Nbr Examens demandés -->
			<div class="flex items-center p-4 bg-white rounded-lg shadow-sm">
				<div
					class="flex items-center justify-center w-12 h-12 rounded-full bg-amber-100 text-amber-600 text-xl mr-4">
					🧪</div>
				<div>
					<div class="text-sm text-gray-500">Nbr examens demandés</div>
					<div class="text-2xl font-semibold text-gray-900">{{ stats.requestedExamsCount }}</div>
				</div>
			</div>

			<!-- Total Dépenses -->
			<div class="flex items-center p-4 bg-white rounded-lg shadow-sm">
				<div
					class="flex items-center justify-center w-12 h-12 rounded-full bg-rose-100 text-rose-600 text-xl mr-4">
					💰</div>
				<div>
					<div class="text-sm text-gray-500">Total dépenses du patient</div>
					<div class="text-2xl font-semibold text-gray-900">{{ stats.totalExpenses | frNumber }}</div>
				</div>
			</div>

			<!-- Moyenne dépenses par mois -->
			<div class="flex items-center p-4 bg-white rounded-lg shadow-sm">
				<div
					class="flex items-center justify-center w-12 h-12 rounded-full bg-cyan-100 text-cyan-600 text-xl mr-4">
					📈</div>
				<div>
					<div class="text-sm text-gray-500">Moyenne dépenses du patient par mois</div>
					<div class="text-2xl font-semibold text-gray-900">{{ stats.averageMonthlyExpenses | frNumber }}
					</div>
				</div>
			</div>

			<!-- Coût Santé -->
			<div class="flex items-center p-4 bg-white rounded-lg shadow-sm">
				<div
					class="flex items-center justify-center w-12 h-12 rounded-full bg-slate-100 text-slate-600 text-xl mr-4">
					🩺</div>
				<div>
					<div class="text-sm text-gray-500">Coût santé</div>
					<div class="text-2xl font-semibold text-gray-900">{{ stats.totalExpensesBeforeCoverage | frNumber }}
					</div>
				</div>
			</div>

			<!-- Coût moyen par mois -->
			<div class="flex items-center p-4 bg-white rounded-lg shadow-sm">
				<div
					class="flex items-center justify-center w-12 h-12 rounded-full bg-indigo-100 text-indigo-600 text-xl mr-4">
					📊</div>
				<div>
					<div class="text-sm text-gray-500">Coût moyen par mois</div>
					<div class="text-2xl font-semibold text-gray-900">{{
						stats.averageGeneralMonthlyExpensesBeforeCoverage |
						frNumber }}</div>
				</div>
			</div>

			<div class="flex items-center p-4 bg-white rounded-lg shadow-sm"
				title="Ce montant correspond aux frais avancés pour vous par votre couverture santé (IPM, assurance ou employeur) et que vous devez lui restituer.">
				<div
					class="flex items-center justify-center w-12 h-12 rounded-full bg-indigo-100 text-indigo-600 text-xl mr-4">
					📊</div>
				<div>
					<div class="text-sm text-gray-500">Montant à rembourser à votre couverture santé</div>
					<div class="text-2xl font-semibold text-gray-900">{{ amountToBeReimbursed | frNumber }}</div>
				</div>
			</div>
		</div>
	</ng-container>

	<!-- Vos documents importants -->
	<div class="my-6" *ngIf="importantDocuments$ | async as docs">
		<h5 class="text-[14px] text-gray-700 font-semibold! mb-3"
			*ngIf="(docs.items?.length ?? docs.data?.length ?? docs.documents?.length ?? docs.length) > 0">
			Vos documents importants
		</h5>

		<div class="grid grid-cols-1 md:grid-cols-2  gap-4">
			<div *ngFor="let doc of (docs.items || docs.data || docs.documents || docs)"
				class="p-4 bg-white rounded-lg shadow-sm border border-gray-100">
				<!-- Document card -->

				<div class="flex items-center justify-between">
					<div class="flex items-center gap-2">

						<!--  -->
						<lucide-icon [img]="FileTextIcon" name="file-text" size="40"
							class="text-color-icon"></lucide-icon>
						<!-- Document details -->
						<div class="flex flex-col ">
							<!-- Filename row (bold, truncated with tooltip) -->
							<div class=" font-semibold text-gray-900 text-sm truncate" [title]="doc.filename">
								{{ doc.filename }}
							</div>

							<!-- Type row -->
							<div class="text-xs text-gray-500  truncate">
								{{ doc.documentType?.label }}
							</div>

							<span class="text-[11px] opacity-50">{{ doc.contract ? ('contracts/' +
								doc.contract.contractCustomId) + '/documents' : 'dossier-patient/documents' }}</span>

							<!-- Date row (French locale) -->
							<div class="text-[11px] text-gray-400 " *ngIf="doc.createdAt">
								{{ doc.createdAt ? (doc.createdAt | date:'Créé le dd/MM/yyyy à HH:mm') : '-' }}
							</div>
						</div>
					</div>
					<!-- eye button -->
					<button type="button" class="text-gray-500  cursor-pointer" title="Voir le document"
						(click)="onViewImportantDocument(doc)" aria-label="Voir le document">
						<!-- eye icon -->
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
							stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
							<path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z" />
							<circle cx="12" cy="12" r="3" />
						</svg>
					</button>
				</div>


			</div>
		</div>
	</div>

	<p class="mt-2 text-[#141414] text-lg! font-semibold!">Vous pouvez dès à présent consulter :</p>

	<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 my-2 mb-8">
		<div *ngFor="let menuItem of visibleMenuItems$ | async"
			class="h-40 rounded-lg overflow-hidden group cursor-pointer" (click)="menuItem.navigate()">
			<div class="w-full h-full transition-transform duration-300 ease-in-out group-hover:scale-101"
				[style.background-image]="'url(' + menuItem.image + ')'"
				style="background-size: cover; background-position: center;">
				<div class="flex items-center bg-[#00000040] w-full h-full">
					<div
						class="w-full flex justify-center text-[12px] text-white font-semibold! uppercase bg-[#00000090] py-1">
						{{ menuItem.label }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>